import React from 'react';
import { Form, Switch, Spin, Input, Tooltip, Select, Row, Col, Button, Upload, Icon, notification,InputNumber } from 'antd';

const FormItem = Form.Item;

function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class SaleTeamForm extends React.Component {
    constructor() {
        super();
        this.state = {
            email : "",

        }
    }

    componentDidMount() {
        this.setState ( {
            email : ""
        })
    }

    handleSubmit = e => {
        e.preventDefault();

        if (this.submittedAt > Date.now() - 500) {
            return;
        }
        
        this.submittedAt = Date.now();

        this.props.form.validateFields((err, fieldsValue) => {
            if (err) {
                return;
            }
            this.props.submit(fieldsValue);
            
        })
    }


  
    render() {
        const formItemLayout = {
            labelCol: {
            xs: { span: 24 },
            sm: { span: 24 },
            },
            wrapperCol: {
            xs: { span: 24 },
            sm: { span: 24 },
            },
        };
        const { getFieldDecorator, getFieldsError } = this.props.form;
        return (
            <div style={{direction: 'rtl'}}>
            <Form onSubmit={this.handleSubmit}>
                <Row>
                    <Col span={10} offset={1}>

                    </Col>

                    <Col span={11} offset={1}>
                       

                        <FormItem
                            {...formItemLayout}
                            label={"ایمیل"}
                            colon={true} >
                            {getFieldDecorator('email', {
                                rules: [{
                                required: true,
                                email :true,
                                 message: 'ایمیل را وارد کنید : ',
                                }],
                            })(
                                <Input />
                            )}
                        </FormItem>
                    </Col>


            </Row>

                <FormItem>
                    <div className="btn-container">
                        <Button
                            type="primary"
                            htmlType="submit"
                            disabled={hasErrors(getFieldsError()) || this.props.submitted}
                        >
{this.props.submitted ? 'منتظر بمانید' : ' ثبت'}
                        </Button>
                    </div>
                </FormItem>
            </Form>
        </div>
        )
    }
}
SaleTeamForm.defaultValue = {
    initialData: {}
}

export default Form.create()(SaleTeamForm);



// WEBPACK FOOTER //
// ./src/containers/SaleTeam/form.js